export default __webpack_public_path__ + "static/Advanced-intelligent-solutions-80a9aa56781a58d2633799f055c13b2d.webp";